<template>
  <el-tooltip
    class="item"
    effect="dark"
    placement="top-start"
    >
    <div
      slot="content"
      class="tool-tip-content"
      >
      {{ langName }} {{ code }}
    </div>
    <span :class="flagClass"></span>
  </el-tooltip>
</template>

<script>

export default {
  name: 'flag-item',
  props: {
    id: {
      type: Number
    },
    code: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    flagClass () {
      return 'fi fi-' + this.getFlagCode(this.code)
    },
    langName () {
      let langs = Object.assign({}, this.$store.getters.languageList)
      if (langs && this.id !== undefined && langs[this.id] !== undefined) {
        return langs[this.id].name || ''
      }
      return ''
    }
  },
  methods: {
    getFlagCode (code) {
      if (code !== undefined) {
        var n = code.indexOf('-')
        if (n !== -1) {
          code = code.substring(n + 1, code.length)
        }
        return code.toLowerCase()
      }
    }
  },
  watch: {
  }
}
</script>
